import React from "react";
import { Link } from "react-router-dom";
import { TextField, Modal, Box, FormControl, DialogActions } from "@mui/material";

export default function AddFolder(props) {
  return (
    <>
      <Modal open={props.openaddfolder} onClose={props.handleCloseaddfolder} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common popup-w35 ">
       
            <div className="card-item__content">
              <div class="card-title">
                <h2>Add New Folder</h2>
                <span>View, download or delete knowledge used by your brain</span>
              </div>
              <Link className="close" onClick={props.handleCloseaddfolder}>
                X
              </Link>
            </div>
            <div className="modal-body">
            <div className="popup_scroller">
            <div className="popup-knowledge">
              <div className="whatpdf_wrapper">
                <div className="setting_upload">
                  <div className="row">
                    <div className="col-md-12 ">
                      <div className="form-group mb-4">
                        <FormControl fullWidth>
                          <TextField id="outlined-multiline-flexible" label="Enter folder name" />
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </div>

                <DialogActions>
                  <button type="button" className="btn btn-default" onClick={props.handleCloseaddfolder}>
                    Close
                  </button>
                  <button type="button" className="btn btn-primary" onClick={props.handleCloseaddfolder}>
                    Submit
                  </button>
                </DialogActions>
              </div>
            </div>
          </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
